import { format } from 'date-fns';
import nb from 'date-fns/locale/nb';

const formatDate = (dateInput) => {
    if (!dateInput) return 'Ingen dato';

    let parsedDate;

    // Prøv ISO-format
    if (!isNaN(Date.parse(dateInput))) {
        parsedDate = new Date(dateInput);
    }

    // Prøv egendefinert format (dd.MM.yyyy, HH:mm:ss)
    if (!parsedDate || isNaN(parsedDate.getTime())) {
        const parts = dateInput.split(', ');
        if (parts.length === 2) {
            const [datePart, timePart] = parts;
            const [day, month, year] = datePart.split('.').map(Number);
            const [hours, minutes, seconds] = timePart.split(':').map(Number);
            parsedDate = new Date(year, month - 1, day, hours, minutes, seconds || 0);
        }
    }

    if (!parsedDate || isNaN(parsedDate.getTime())) {
        console.error('Ugyldig datoformat:', dateInput);
        return 'Ugyldig dato';
    }

    return format(parsedDate, 'dd.MM.yyyy HH:mm', { locale: nb });
};

export default formatDate;
